import { Notifications, notifications } from '@mantine/notifications';
import { type FC, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { getNotificationMessage } from '@/components/notification-wrapper/notification-wrapper.util.ts';
import useAppStore, { NotificationOperation } from '@/store/app.ts';

export const NotificationWrapper: FC = () => {
	const { notification, setNotification } = useAppStore(
		useShallow((state) => ({
			setNotification: state.setNotification,
			notification: state.notification
		}))
	);

	useEffect(() => {
		if (notification) {
			const isRemoveOperation = [
				NotificationOperation.REMOVE,
				NotificationOperation.REMOVE_FROM_CANVAS
			].includes(notification.operation);
			notifications.show({
				id: 'operation-toast',
				color: isRemoveOperation ? 'red' : 'green',
				position: 'top-left',
				message: getNotificationMessage(
					notification.operation,
					notification.data.title
				),
				autoClose: 3000,
				onClose: () => {
					setNotification(null);
				}
			});
		}
	}, [notification, setNotification]);
	return <Notifications zIndex={300} />;
};
